import { restClient } from '../config/restClient'

const endpoint = companyId => `/api/company/profiles/${companyId}/candidate_impressions`

export const postImpressions = async (companyId, data) => {
  const response = await restClient(endpoint(companyId), {
    method: 'POST',
    data,
  })
  return response.data
}
